import {Component, inject, input, Type} from '@angular/core';
import {from, Observable, of, switchMap} from 'rxjs';
import {tenants} from '../../tenant.component';
import {TenantService} from '../../services/tenant.service';
import {Tenant} from '../../../environments/env.type';
import {AsyncPipe, NgComponentOutlet} from '@angular/common';
import {toObservable} from '@angular/core/rxjs-interop';
export function getComponentType(
  componentSlot: string,
  activeTenant: Tenant
): Observable<Type<any>> {
  const slotConfig = tenants[componentSlot];
  if (!slotConfig) {
    throw new Error(`Component slot "${componentSlot}" not found in tenant registry`);
  }
  const componentLoader = slotConfig[activeTenant] || slotConfig['**'];
  if (!componentLoader) {
    throw new Error(`No component loader found for slot "${componentSlot}" and tenant "${activeTenant}"`);
  }
  return from(componentLoader);
}
@Component({
  selector: 'app-tenant-loader',
  imports: [NgComponentOutlet, AsyncPipe], // ✅ corrigé
  templateUrl: './tenant-loader.component.html',
  styleUrl: './tenant-loader.component.scss',
  standalone: true,
})
export class TenantLoaderComponent {
  slot = input.required<string>();

  private tenantService = inject(TenantService);
  private activeTenant: Tenant = this.tenantService.getActiveTenant();

  // ✅ réactif : si jamais `slot` change, le composant se recharge automatiquement
  componentType$: Observable<Type<any>> = toObservable(this.slot).pipe(
    switchMap(slot => getComponentType(slot, this.activeTenant))
  );
}
